<template>
  <v-container>
    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <h1
          v-if="$route.params.id"
        >
          Editing {{ form.title }}
        </h1>
        <h1
          v-else
        >
          Create A New Event
        </h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout row wrap>
              <v-flex sm12 class="my-3">
                <v-text-field
                  v-model="form.title"
                  :counter="60"
                  :rules="titleRules"
                  label="Title"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="form.eventLocation"
                  label="Event Location"
                  required
                ></v-text-field>

                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-menu
                      ref="startMenu"
                      v-model="startMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="startMenu"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.start"
                          label="Start Date"
                          prepend-icon="event"
                          readonly
                          required
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form.start" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="startMenu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.startMenu.save(form.startDate); startMenu = false">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      ref="endMenu"
                      v-model="endMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="endMenu"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.end"
                          label="Start Date"
                          prepend-icon="event"
                          readonly
                          required
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form.end" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="endMenu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.endMenu.save(form.end); endMenu = false">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>

                Featured Image
                <upload-button
                  :title="`Featured Image`"
                  :placeholder="form.imageFeatured"
                  :selectedCallback="uploadImage"
                  :modelTarget="'form.imageFeatured'"
                ></upload-button>

                <h3>Gallery of Images</h3>
                <v-layout row wrap>
                  <upload-button
                    v-for='(image, index) in form.imageGallery'
                    :key="image"
                    :title="`Gallery ${index + 1}`"
                    :placeholder="image"
                    :selectedCallback="uploadImage"
                    :modelTarget="`form.imageGallery[${index}]`"
                  ></upload-button>
                </v-layout>
                <v-btn @click="addImages()">
                  Add Images
                </v-btn>

                <v-textarea
                  v-model="form.eventDescription"
                  :rules="descriptionRules"
                  label="Description"
                ></v-textarea>

                <v-textarea
                  v-model="form.tdInvolvement"
                  label="TD Lab Involvement"
                ></v-textarea>

                <v-text-field
                  v-model="form.externalUrl"
                  :rules="externalUrlRules"
                  label="Event URL"
                ></v-text-field>

                <v-text-field
                  v-model="form.eventAttendance"
                  :rules="eventAttendanceRules"
                  label="Event Attendance"
                ></v-text-field>

                <v-checkbox
                  v-model="form.publish"
                  label="Publish to the site"
                  required
                  color="primary"
                ></v-checkbox>

                <v-btn :disabled="!valid" @click="validate">Validate</v-btn>

              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db, storage, CurrentTime } from '@/db.js'
import camelCase from 'lodash.camelcase'
import cloneDeep from 'lodash.clonedeep'
import { dataURLToBlob, isUrl } from '@/util/index.js'
import uploadButton from '@/components/uploadButton.vue'
import set from 'lodash/set'

export default {
  name: 'createEvent',
  components: {
    uploadButton
  },
  data () {
    return {
      form: {
        start: new Date().toISOString().substr(0, 10),
        end: '',
        imageFeatured: '',
        imageGallery: [''],
        publish: false,
        tdInvolvement: '',
        title: '',
        externalUrl: '',
        eventLocation: '',
        eventDescription: '',
        eventAttendance: 0,
        uri: ''
      },
      uri: '',
      valid: false,
      startMenu: false,
      endMenu: false,
      titleRules: [
        v => !!v || 'Title is required',
        v => (v && v.length <= 60) || 'Title must be less than 60 characters'
      ],
      descriptionRules: [
        v => !!v || 'Description is required'
      ],
      externalUrlRules: [
        v => !!v || 'Event URL is required',
        v => isUrl(v) || 'Event URL needs to be a valid URL.'
      ],
      eventAttendanceRules: [
        v => Number(v) >= 0 || 'Attendance needs to be a number.'
      ]
    }
  },
  created () {
    let vm = this

    // fetch Firebase if ID is in router
    if (this.$route.params.id) {
      this.uri = this.$route.params.id

      db.collection('events')
        .doc(this.uri)
        .get()
        .then(response => {
          vm.form = response.data()
        })
        .catch(error => {
          throw new Error(error)
        })
    }
  },
  methods: {
    addImages () {
      this.form.imageGallery.push('')
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.submit()
      }
    },
    submit () {
      let vm = this
      vm.form.uri = this.uri.length > 0
        ? this.uri
        : `${this.form.title}_${this.form.start}`
      db.collection('events')
        .doc(vm.form.uri)
        .set(vm.form, {
          merge: true
        })
        .then(() => {
          vm.triggerSnackbar('Successful write to database')
        })
        .catch(error => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
    },
    uploadImage (e, scopeTarget) {
      let vm = this
      if (e['name'] && scopeTarget.length) {
        storage
          .images(
            `event` +
            vm.form.title +
            e.name
          )
          .put(e)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .then(url => {
            vm.$nextTick(() => {
              set(vm, scopeTarget, url)

              // force dom re-render
              vm.form.imageGallery.push('')
              vm.$nextTick(() => {
                vm.form.imageGallery.pop()
              })
            })
          })
      }
    },
    triggerSnackbar (text) {
      this.$store.dispatch('setsnackbarOptions', {
        text: text,
        btnText: 'Close'
      })
    }
  }
}
</script>
